import React from 'react';
import {connect} from "react-redux";
import CustomPaper from './../../../../shared/utils/CustomPaper';
import {
    Step,
    Stepper,
    StepButton,
} from 'material-ui/Stepper';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import AuthService from './../../../../../services/AuthService';
import moment from './../../../../shared/utils/moment_fr';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';
import Page4 from './Page4';
import Page5 from './Page5';
import Page6 from './Page6';
import {getEntretienHeader} from "../../../../../actions/entreprise/actions_entreprise_entretien";
import pdfHandler from "../../../../shared/utils/pdfHandler";


class EntretienWrapper extends React.Component {

    constructor(props){
        super(props);
        this.getStepContent = this.getStepContent.bind(this);
        this.Auth = new AuthService();
        this.getRoute = this.getRoute.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
    }

    componentDidMount(){
        const id_entretien = this.props.match.params.id_entretien;
        this.props.dispatch(getEntretienHeader(id_entretien));

    }

    downloadFile(id){
        this.Auth.fetch(`/services/pdf/entretien/${id}?is_apercu=true`, {responseType: 'arraybuffer'})
            .then(resp=>pdfHandler(resp.data, 'apreçu_entretien_professionnel.pdf'));
    }

    getStepContent(){
        const stepIndex = this.props.match.params.step_index;
            switch (parseInt(stepIndex, 10)){
                case 1 :
                    return <Page1 />;
                case 2 :
                    return <Page2 />;
                case 3 :
                    return <Page3 />;
                case 4 :
                    return <Page4 />;
                case 5 :
                    return <Page5 />;
                case 6 :
                    return <Page6 />;
                default:
                    return null;
            }


    }

    getRoute(id_entretien, stepIndex){
        return `/entreprise/passer_entretien/${id_entretien}/${stepIndex}`;
    }


    render() {
        const stepIndex = this.props.match.params.step_index;
        const eh = this.props.entretienHeader;
        const salarie = eh.nom +" "+eh.prenom;
        const content = this.getStepContent();
        if(eh.done === "YES"){
            return (
                <CustomPaper title={'Entretien signé'}>
                    Cet entretien est déjà signé, il est impossible de le modifier.
                </CustomPaper>);
        }
        return (
            <CustomPaper title={'Entretien Professionnel'}>
                <div style={{minHeight:600, position: 'relative', paddingBottom:70}} >
                    <table style={{fontSize:12}} className={'table table-sm'}>
                        <thead>
                            <tr>
                                <th >Salarié</th>
                                <th >Numéro du salarié</th>
                                <th >Id entretien</th>
                                <th >Date début d'entretien</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{salarie}</td>
                                <td>{eh.num_salarie}</td>
                                <td>{eh.id}</td>
                                <td>{moment(eh.date_heure).format('lll')}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div className={'invisible-900'}>
                        <Stepper linear={false} activeStep={stepIndex -1 }>
                            <Step>
                                <StepButton onClick={() => this.props.history.push(this.getRoute(eh.id, 1))}>
                                    Infos salarié
                                </StepButton>
                            </Step>
                            <Step>
                                <StepButton onClick={() => this.props.history.push(this.getRoute(eh.id, 2))}>
                                    Formations
                                </StepButton>
                            </Step>
                            <Step>
                                <StepButton onClick={() => this.props.history.push(this.getRoute(eh.id, 3))}>
                                    Perspectives d'évolution
                                </StepButton>
                            </Step>
                            <Step>
                                <StepButton onClick={() => this.props.history.push(this.getRoute(eh.id, 4))}>
                                    Description du poste
                                </StepButton>
                            </Step>
                            <Step>
                                <StepButton onClick={() => this.props.history.push(this.getRoute(eh.id, 5))}>
                                    Projet envisagé
                                </StepButton>
                            </Step>
                            <Step>
                                <StepButton onClick={() => this.props.history.push(this.getRoute(eh.id, 6))}>
                                    Fin
                                </StepButton>
                            </Step>
                        </Stepper>
                    </div>
                        {content}
                        <div style={{position: 'absolute', bottom:0}}>
                            <FlatButton
                                label="Précédent"
                                disabled={parseInt(stepIndex, 10) === 1}
                                onClick={() => this.props.history.push(this.getRoute(eh.id, parseInt(stepIndex, 10) - 1))}
                                style={{marginRight: 12}}
                            />
                            <RaisedButton
                                label="Suivant"
                                disabled={parseInt(stepIndex, 10) === 6}
                                primary={true}
                                onClick={() => this.props.history.push(this.getRoute(eh.id, parseInt(stepIndex, 10) + 1))}
                                style={{marginRight: 12}}
                            />
                            <div className={'hidden-small'}>
                                <RaisedButton
                                    backgroundColor={'pink'}
                                    label="Voir un aperçu de cet entretien"
                                    onClick={() => this.downloadFile(this.props.entretienHeader.id)}
                                    style={{marginRight: 12}}
                                />
                                <RaisedButton
                                    backgroundColor={'red'}
                                    labelColor={'white'}
                                    label="Supprimer cet entretien"
                                    onClick={() => {
                                        const c = window.confirm('Êtes vous sûr de vouloir supprimer cet entretien ?');
                                        if(c){
                                            this.Auth.fetch('/societe/entretien/'+eh.id, {method:'delete'})
                                                .then(resp => {
                                                    window.alert('Entretien supprimé avec succès.');
                                                    this.props.history.push('/entreprise/passer_entretien');
                                                });
                                        }
                                    }}
                                />
                            </div>
                        </div>
                </div>
            </CustomPaper>
        );
    }
}

function mapStateToProps(store) {
    return {
        entretienHeader : store.entretien.header
    }
}

export default connect(mapStateToProps)(EntretienWrapper);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/entretiens/passer_entretien/EntretienWrapper.js